import { render, staticRenderFns } from "./ManajemenDashboard.vue?vue&type=template&id=21807a1c&scoped=true"
import script from "./ManajemenDashboard.vue?vue&type=script&lang=js"
export * from "./ManajemenDashboard.vue?vue&type=script&lang=js"
import style0 from "./ManajemenDashboard.vue?vue&type=style&index=0&id=21807a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21807a1c",
  null
  
)

export default component.exports